<template>
  <!--Location-->
  <section class="ls s-py-150">
    <div class="container mb-5">
      <div class="row justify-content-center">
        <div class="col-md-5">
          <h3 class="text-center">COA RETRIEVAL</h3>
          <p class="text-center">
            Looking for a COA? Simply enter the Lot number and your email below
            and we will give you a link to the document!
          </p>
        </div>
      </div>
      <div class="row justify-content-center mt-5 mb-5">
        <div class="col-md-6">
          <div class="row mb-3">
            <div class="col-md-5 mt-3">
              <div class="form-group">
                <label>Work Email</label>
                <input
                  type="text"
                  aria-required="true"
                  class="form-control"
                  v-model="email"
                />
              </div>
            </div>
            <div class="col-md-4 mt-3">
              <div class="form-group">
                <label>Lot Number</label>
                <input
                  type="text"
                  aria-required="true"
                  class="form-control"
                  v-model="lotNumber"
                />
              </div>
            </div>
            <div class="col-md-3 mt-3">
              <button
                type="button"
                class="btn-outline-darkgrey py-2 btn-submit"
                @click.prevent="findCoa()"
                :disabled="isLoading"
              >
                <img src="@/assets/img/loading.gif" v-if="isLoading" />
                <span v-else>Find COA</span>
              </button>
            </div>
          </div>
          <div class="row mt-2" v-if="errorMessage">
            <div class="col-md-12">
              <div class="alert alert-danger" role="alert">
                {{ errorMessage }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row justify-content-center mt-5 mb-5">
        <div class="col-md-6" v-if="result != ''">
          <div class="alert alert-success" role="alert">
            If the new page does not open automatically, <a :href="result" target="_blank">click here</a> to view your COA.
          </div>
        </div>
         <div v-if="isLoading" class="text-center my-5">
            <div class="spinner-border text-success" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
        </div>
      </div>
    </div>
    <div class="whatsapp-btn">
      <a class="va-icon" href="https://wa.me/14124632627" target="_blank"
        ><span class="circle"
          ><img src="https://cdn.sionerp.com/new_website/img/cs.svg" /></span
      ></a>
      <a href="https://wa.me/14124632627" target="_blank"> Talk to Experts</a>
    </div>
  </section>
  <!--Posts End-->
</template>
<script>
import axios from "axios";

export default {
  name: "CoaRetrieval",
  data() {
    return {
      apiUrl:
        window.location.hostname == "vanaroma.com" ||
        window.location.hostname == "www.vanaroma.com"
          ? "https://va-api.sionerp.com"
          : "http://localhost:8888/va_api",
      email: "",
      lotNumber: "",
      isLoading: false,
      result: "",
      errorMessage: "",
    };
  },
  mounted() {
    let oldScript = document.getElementById("mainJS");
    if (oldScript) {
      oldScript.remove();
    }
    let mainJS = document.createElement("script");
    mainJS.setAttribute("id", "mainJS");
    mainJS.setAttribute("src", "assets/js/main.js");
    document.body.appendChild(mainJS);
    document.title = "COA Retrieval - Van Aroma";
  },
  methods: {
    isValidEmail(email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    },
    findCoa() {
      this.result = "";
      this.errorMessage = "";

      // Validasi email
      if (!this.email || this.email.trim() === "") {
        this.errorMessage = "Email is required";
        return;
      }

      if (!this.isValidEmail(this.email)) {
        this.errorMessage = "Please enter a valid email address";
        return;
      }

      // Validasi lot number
      if (!this.lotNumber || this.lotNumber.trim() === "") {
        this.errorMessage = "Lot number is required";
        return;
      }

      this.isLoading = true;
      let formdata = new FormData();
      formdata.append("email", this.email);
      formdata.append("lot_no", this.lotNumber);
      let bodyContent = formdata;
      let reqOptions = {
        url: this.apiUrl + "/webx/find_coa/",
        method: "POST",
        data: bodyContent,
      };
      axios
        .request(reqOptions)
        .then((response) => {
          this.result = response.data.data;
          if(this.result){
            window.open(this.result, "_blank");
          }else{
            this.errorMessage = "Data not found. Please make sure your email and lot number are correct.";
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log(error);
          this.isLoading = false;
        });
    },
  },
};
</script>
<style scoped>
.btn-submit {
  height: 50px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.btn-submit:disabled {
  opacity: 0.6;
  border-color: grey;
  cursor: not-allowed;
}
.btn-submit img {
  width: 30px;
  height: 30px;
}
</style>
